<template>
  <main id="container" class="page-container bg-wave5">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="이벤트" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-giftCertificate">
      <div class="container">
        <div class="page-sub-header">
          <h3 class="page-sub-title">
            <span class="green">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3>
        </div>
      </div>
      <div class="page-tab-container">
        <div class="container tab-buttons">
          <!-- <router-link to="eatingOut" class="tab-button">외식 활성화</router-link>
          			<router-link to="dineOut" class="tab-button">오늘 식사 한 끼, 밖에서 먹어요</router-link>
					<router-link to="check" class="tab-button">출석체크</router-link>
					<router-link to="ranking" class="tab-button">랭킹게임</router-link>
					<router-link to="dibs" class="tab-button is-active">찜하기</router-link>
					<router-link to="sns" class="tab-button">구매후기</router-link> -->
          <router-link to="delivery" class="tab-button"
            >공공배달앱 이용후기</router-link
          >
          <router-link to="giftCertificate" class="tab-button is-active"
            >지역사랑상품권 이벤트</router-link
          >
          <!-- <router-link to="challenge" class="tab-button">동행 숨결 챌린지</router-link> -->
        </div>
      </div>
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                  src="@/assets/img/event/giftCertificate.jpg"
                  alt="지역사랑상품권 이벤트"
                />
              </div>
            </div>
            <div class="event-check-header-info">
              <ul class="event-check-header-info-list">
                <li v-for="(item, idx) in infoList" :key="idx">
                  <span class="infolist-title">{{ item.title }}</span>
                  <span class="infolist-text" v-html="item.detail"></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-guide">
            <span class="event-check-guide-title">참여방법</span>
            <div class="event-check-guide-desc no-border">
              <ul class="event-check-guide-desclist">
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/giftCertificate1_3.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 1</span>
                    <span class="desclist-text">지역사랑상품권 카드형 또는 모바일앱으로 3만원 이상 결제</span>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/giftCertificate1_1.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 2</span>
                    <span class="desclist-text">
                      지역사랑상품권 모바일 앱 내 결제 내역 캡처<br>
                      <div class='localpay-text'>-'지역상품권 chak' 이용자의 경우 웹으로 접속하여 캡처<br/></div>
                      <div class='localpay-text'>&nbsp;&nbsp;&nbsp;<a href='https://localpay.komscochak.com/flow/login/' target='_blank'>https://localpay.komscochak.com/flow/login/</a></div>
                      <div class="desclist-tag" style="color: red;">* 해당 지역상품권과 작성일자 보이게 캡처 필수, 동행축제 기간 내 결제 내역만 인정</div>
                    </span>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/giftCertificate1_4.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 3</span>
                    <span class="desclist-text">동행축제 누리집 이벤트 페이지 내 네이버폼에 결제내역 업로드 접수</span>
                    <div class="tag-item">
                      <div class="desclist-tag" v-if="isShowBtn">
                      <span style="font-weight: bold;">* 네이버폼 : https://form.naver.com/response/wHk1MPQrF-4-G50QSN2TDQ</span>
                      <span class="acceptt-button"><a href="https://form.naver.com/response/wHk1MPQrF-4-G50QSN2TDQ" target="_blank" >접수하기</a></span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-products">
            <span class="event-check-products-title">경품소개</span>
            <ul class="event-check-products-list">
              <li
                class="event-check-products-list-li"
                v-for="(item, idx) in prdList"
                :key="idx"
              >
                <div class="event-check-products-item">
                  <div class="event-check-products-item-img">
                    <img
                      :src="require(`@/assets/img/main/${item.img}`)"
                      :alt="item.title"
                    />
                  </div>
                  <div class="event-check-products-item-title">
                    <div class="item-title-wrap">
                      <div class="item-title">{{ item.title }}</div>
                      <div class="item-wrap">
                        <span class="item" v-if="item.person">{{ item.person }}</span>
                        <span class="item" v-if="item.person2">{{ item.person2 }}</span>
                        <span class="item" v-if="item.person3">{{ item.person3 }}</span>
                        <span class="item" v-if="item.person4">{{ item.person4 }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="event-check-button-box">
        <div class="container flex-column">
          <span class="event-check-prect-title">당첨안내</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in deliveryInfo"
              :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
        </div>
        <div class="container flex-column">
          <span class="event-check-prect-title">경품발송</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in deliveryList"
              :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
          <div class="into-area" style="width: 100%; text-align: center">
            <button
              type="button"
              v-if="isShowBtn"
              class="event-check-button"
              @click="clickLink('https://form.naver.com/response/wHk1MPQrF-4-G50QSN2TDQ')"
            >
              참여하기
            </button>
            <!-- <span class="into-button"><a href="https://form.naver.com/response/wHk1MPQrF-4-G50QSN2TDQ" target="_blank">참여하기</a></span> -->
          </div>
        </div>
      </div>
      <div class="event-check-prect">
        <div class="container">
          <span class="event-check-prect-title">유의사항</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in prectList"
              :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <event-terms-modal
      :visible="visibleModal"
      @closeModal="visibleModal = false"
      @agreeModal="prvcMktAgrePopup"
    />
  </main>
</template>
<style>
.prect-list-text a {
  word-break: break-all;
}
.acceptt-button a {
  width: 80px; /* 버튼 너비 유지 */
  height: 25px; /* 버튼 높이 유지 */
  border-radius: 7px;
  display: inline-flex;
  background-color: #ae9eff;
  color: #ffffff;
  font-size: 17px;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
}
.localpay-text {  
  font-size: 16px;
}
@media (max-width: 768px) {
  .localpay-text {
    font-size: 14px;
  }
}
</style>
<script>
import PageHeader from "@/components/content/PageHeader";
import EventTermsModal from "@/components/content/EventTermsModal";
import {
  MUT_SET_RETURN_ROUTE,
  MUT_SHOW_ALERT,
  MUT_SHOW_CONFIRM,
} from "@/store/_mut_consts";
import {
  ACT_SET_PRVC_MKT_AGRC,
  ACT_GET_DHFESTA_EVENT_MNG,
} from "@/store/_act_consts";
import {
  isSuccess,
  dateToDateFormat,
  getItem,
  lengthCheck,
  timestampToDateFormat,
} from "@/assets/js/utils";
import { countDDay } from "@/assets/js/DateUtils";
import { mapGetters } from "vuex";
export default {
  name: "EventGiftCertificate",
  components: { PageHeader, EventTermsModal },
  data: () => ({
    visibleModal: false,
    infoList: [
      {
        title: "참여기간",
        detail: "2025년 9월 1일(월) ~ 2025년 9월 30일(화)",
      },
      {
        title: "결과발표",
        detail: "2025년 11월 중",
      },
      {
        title: "경품발송",
        detail: "2025년 11월 중",
      },
      {
        title: "진행방식",
        detail: "지역사랑상품권 사용 후 전자영수증 캡처 후 네이버폼 접수<br><span>지역사랑상품권 찾기 : <a href='https://www.laiis.go.kr/lips/mlo/lcl/localGiftList.do' target='_blank'>https://www.laiis.go.kr/lips/mlo/lcl/localGiftList.do</a></span>",
      },
    ],
    weekList: [
      {
        name: "일",
        eng: "SUN",
      },
      {
        name: "월",
        eng: "MON",
      },
      {
        name: "화",
        eng: "TUE",
      },
      {
        name: "수",
        eng: "WED",
      },
      {
        name: "목",
        eng: "THU",
      },
      {
        name: "금",
        eng: "FRI",
      },
      {
        name: "토",
        eng: "SAT",
      },
    ],
    prdList: [
      {
        img: "item_gift_certificate.jpg",
        title: "디지털 온누리상품권",
        person: "100만원 3명",
        person2: "50만원 6명",
        person3: "10만원 20명",
        person4: "5만원 20명"
      },
      
      {
        img: "item_chicken.jpg",
        title: "치킨+콜라 쿠폰",
        person: "(34명)",
      },
      {
        img: "item_coffee.png",
        title: "커피 쿠폰",
        person: "(100명)",
      },
    ],
    deliveryInfo: [
      "네이버폼 접수자 대상 미션 검수 후, 추첨을 통해 당첨자 선정",
    ],
    deliveryList: [
      "5만원 이하 경품 : 네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
      "5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내와 개인정보, 고유식별정보 수집·이용 및 제공 동의 → 제세공과금 납부 확인 후 네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
    ],

    prectList: [
      "본 이벤트는 동행축제 기간 내 지역사랑상품권 결제 후 동행축제 누리집 또는 카카오톡 채널 이벤트 페이지 내 네이버 폼에 접수해 주시면 응모 완료됩니다.",
      "해당 이벤트에 만 14세 미만은 참여할 수 없습니다. (만 14세 미만 참여자의 경우 경품 당첨이 취소됩니다.)",
      '<span style="color: red;">작성일자 보이게 캡처 필수, 이벤트 기간 내 결제 내역만 미션으로 인정됩니다.',
      '5만원 초과 경품 당첨의 경우 제세공과금(22%)는 본인 부담해야 합니다',
      '<span style="color: red;">디지털 온누리상품권의 경우 디지털온누리앱에 가입한 자에게 선물하기를 통해 경품 지급될 예정입니다.</span> <br>*구글플레이스토어 : <a href="https://play.google.com/store/apps/details?id=com.komsco.kpay" target="_blank">https://play.google.com/store/apps/details?id=com.komsco.kpay</a><br>*앱스토어 : <a href="https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450" target="_blank">https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450</a>',
      '<span style="color: red;">이름과 휴대폰 번호가 디지털온누리앱 가입 정보와 일치한 경우에만 선물을 받을 수 있습니다.',
      "당첨자의 잘못된 정보 입력으로 인해 경품 누락 될 경우 재발송되지 않습니다.",
      "지급된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.",
      "당첨 쿠폰이 분실 및 도난 된 경우, 재발송 불가합니다. (당첨 쿠폰 복사 및 저장 필수)",
      "이벤트 참여 응모를 위한 네이버폼으로 취합 된 개인정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기됩니다.",
      "이벤트 일정 및 경품 내역은 추후 주최 측의 사정에 따라 변동 가능합니다.",
      '이벤트에 관한 문의는 대행사인 <span style="font-weight: bold;">㈜지엠컴 070-4838-6391</span>로 문의 바라며, 상담 가능 시간은 평일 오전 10시 ~ 오후 7시입니다.',      
    ],
    eventStart: false,
    isEvnt: true,
    evntStrtDt: "",
    evntEndDt: "",
  }),
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
    isShowBtn() {
      return new Date() > new Date("2025-09-01 00:00:00") &&
        new Date() < new Date("2025-09-30 23:59:59");
    },
  },
  watch: {},
  filters: {
    getAddMonthKorFilter(val, idx) {
      if (val === "") return "";
      const date = new Date(val);
      let year = date.getFullYear();
      let month = (date.getMonth() + idx + 1) % 13;
      if (month >= 0) {
        year += 1;
        month += 1;
      }
      return `${year}년  ${month}월 중`;
    },
  },
  async created() {
    await this.getEvntMng();
    if (!this.isEvnt) return;
    const tagetDate = new Date(this.evntStrtDt);
    const endDate = new Date(this.evntEndDt);
    // const nowDate = new Date();
    const nowDate = dateToDateFormat(new Date(), "yyyy-MM-dd") + " 00:00";
    // console.log(countDDay(tagetDate, nowDate));
    // console.log(countDDay(nowDate, endDate));
    // if (nowDate > tagetDate || nowDate < endDate) {
    if (countDDay(tagetDate, nowDate) < 0 || countDDay(nowDate, endDate) < 0) {
      this.eventStart = false;
    } else {
      this.eventStart = true;
    }

    // this.infoList[0].detail = this.isEvnt ? this.dateKorConvert(this.evntStrtDt) + ' ~ ' + this.dateKorConvert(this.evntEndDt) : '';
    // this.infoList[1].detail = this.isEvnt ? this.evntEndDt : '';
    // this.infoList[2].detail = this.isEvnt ? this.evntEndDt : '';
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const thisTab = document.querySelector(".tab-button.is-active");
        thisTab.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    });
  },
  methods: {
    clickAtndCheckEvent(e) {
      if (!this.eventStart) {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "이벤트 기간이 아닙니다.",
        });
        return;
      }

      if (!this.chkLogin("로그인 후 이벤트 참여가 가능합니다.")) return false;
      //개인정보 동의 후 진행할 수 있도록 수정
      if (this.campn.prvcMktAgreYn === "N") {
        this.visibleModal = true;
      } else {
        this.$router.push("/ko/products/category");
      }
    },
    chkLogin(title) {
      if (typeof this.session.userId == "undefined") {
        const param = {
          title: title,
          html: true,
          showCancelButton: true,
          yesfunc: () => {
            this.$store.commit(
              `common/${MUT_SET_RETURN_ROUTE}`,
              this.$route.path
            );
            this.$router.push({ name: "Login" });
          },
          nofunc: () => {},
        };
        this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, param);
        return false;
      }

      return true;
    },
    showAlert(msg) {
      this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: msg });
    },
    async prvcMktAgrePopup() {
      await this.$store
        .dispatch(`information/${ACT_SET_PRVC_MKT_AGRC}`, {
          campnId: this.campn.campnId,
        })
        .then((res) => {
          if (isSuccess(res)) {
            this.campn.prvcMktAgreYn = "Y";
            this.visibleModal = false;
            this.$router.push("/ko/products/category");
          } else {
            this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
              title: "오류가 발생했습니다. 다시 시도해주세요.",
            });
          }
        });
    },
    dateKorConvert(val) {
      const date = new Date(val);
      return `${date.getFullYear()}년  ${("0" + (date.getMonth() + 1)).slice(
        -2
      )}월 ${("0" + date.getDate()).slice(-2)}일 (${
        this.weekList[date.getDay()].name
      })`;
    },
    async getEvntMng() {
      this.isEvnt = false;
      this.evntStrtDt = "";
      this.evntEndDt = "";

      await this.$store
        .dispatch(`event/${ACT_GET_DHFESTA_EVENT_MNG}`, {
          campnId: this.campn.campnId,
          evntTyp: "20",
        })
        .then((res) => {
          if (lengthCheck(res)) {
            const item = getItem(res);

            this.evntStrtDt =
              timestampToDateFormat(Number(item.evntStrtDt), "yyyy-MM-dd") +
              " 00:00";
            this.evntEndDt =
              timestampToDateFormat(Number(item.evntEndDt), "yyyy-MM-dd") +
              " 00:00";

            this.isEvnt = true;
          } else {
            this.evntStrtDt = this.campn.strtDt;
            this.evntEndDt = this.campn.endDt;
          }
        });
    },
    clickLink(url) {
      window.open(url, "_blank");
    },
  },
  // metaInfo() {
  //   return {
  //     title: "지역사랑상품권 이벤트 | 동행축제",
  //     link: [
  //       {
  //         rel: "canonical",
  //         href: "https://www.k-shoppingfesta.org/ko/event/giftCertificate",
  //       },
  //       {
  //         rel: "alternate",
  //         hreflang: "ko",
  //         href: "https://www.k-shoppingfesta.org/ko/event/giftCertificate",
  //       },
  //       {
  //         rel: "alternate",
  //         hreflang: "x-default",
  //         href: "https://www.k-shoppingfesta.org/ko/event/giftCertificate",
  //       },
  //     ],
  //   };
  // }
};
</script>
